import { FAQ, waLink } from "../data";

export const FAQSection = () => (
  <section className="section alt" id="faq" data-testid="faq-section">
    <div className="container two-col">
      <div>
        <span className="section-tag">Problemas & Soluções</span>
        <h2>Perguntas frequentes sobre desentupidora 24 horas no litoral</h2>
        <p>
          Respostas objetivas sobre preço, prevenção, tempo de chegada nas cidades do
          litoral, garantia e o efeito da maresia nos entupimentos.
        </p>
        <div className="faq">
          {FAQ.map((f, i) => (
            <details key={i} data-testid={`faq-item-${i}`}>
              <summary>{f.q}</summary>
              <div className="faq-body">{f.a}</div>
            </details>
          ))}
        </div>
        <a
          className="btn btn-wa faq-cta"
          href={waLink("Olá! Tenho uma dúvida sobre desentupimento no litoral.")}
          rel="noopener noreferrer"
          target="_blank"
          data-testid="faq-whatsapp-btn"
        >
          💬 Tirar dúvida no WhatsApp
        </a>
      </div>
      <div>
        <div className="img-card" style={{ marginTop: 0 }}>
          <img
            src="/img/limpeza-de-fossa-litoral-sp.webp"
            alt="Técnico da Desentope Maresias realizando limpeza de fossa em pousada no litoral de São Paulo com caminhão a vácuo"
            loading="lazy"
            width="540"
            height="360"
          />
        </div>
      </div>
    </div>
  </section>
);
